import React from 'react'
import styles from './pucWidgetShimmer.module.scss'

const PucShimmer = () => (
    <div className={styles.pucExpired}>
      <div className={styles.pucShimmer} />
      <div className={styles.pucText}>
        Pollution certificate is <span className={styles.pucExpiredStatus} />
      </div>
      <div className={styles.pucDate} />
    </div>
  )

export default PucShimmer
